import React, { useState } from "react";
import { TextField, Grid } from "@mui/material";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import ContactSnackbar from "./ContactSnackbar";
import axios from "axios"; // Import axios for HTTP request

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple frontend validation
    if (!form.name || !form.email || !form.message) {
      setSnackbar({
        open: true,
        message: "Please fill in all fields.",
        severity: "error",
      });
      return;
    }

    try {
      //  Send POST request to Django backend
      await axios.post("http://localhost:8000/api/contact/submit/", form);

      setSnackbar({
        open: true,
        message: "Message sent successfully!",
        severity: "success",
      });

      setForm({ name: "", email: "", message: "" }); // Clear form
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to send message. Please try again.",
        severity: "error",
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <MKBox
      component="form"
      onSubmit={handleSubmit}
      maxWidth={600}
      width="100%"
      bgcolor="white"
      p={4}
      borderRadius="lg"
      boxShadow="xl"
      mb={6}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            name="name"
            label="Your Name"
            value={form.name}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            name="email"
            label="Your Email"
            value={form.email}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            name="message"
            label="Your Message"
            value={form.message}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <MKButton type="submit" color="info" variant="gradient" fullWidth>
            Send Message
          </MKButton>
        </Grid>
      </Grid>

      {/* Snackbar Notification */}
      <ContactSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        handleClose={handleCloseSnackbar}
      />
    </MKBox>
  );
}
